import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../../common/constants';
import { listEverbridgeGroupUrl } from '../../../config';
import { RootState } from '../../../store';
import api from '../../../api';
import {
  IEverbridgeGroupApi,
  IEverbridgeGroups,
} from '../../../common/types/everbridgeTypes';
import { getCookie } from '../../../common/utils';

export const GET_EVERBRIDGEGROUP: string = 'getEverbridgeGroup';

const initialState: IEverbridgeGroupApi = {
  everbridgeGroup: null,
  status: Status.IDLE,
  msg: null,
  error: null,
};

export const fetchEverbridgeGroupData = createAsyncThunk(
  GET_EVERBRIDGEGROUP,
  async (_, { rejectWithValue }) => {
    try {
      const emailId: string = decodeURIComponent(getCookie('email'));
      const response = await api.get(
        `${listEverbridgeGroupUrl}email=${emailId}`
      );
      const everbridgeGroupData: IEverbridgeGroups = response.data;
      return everbridgeGroupData;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const listEverbridgeGroupSlice = createSlice({
  name: GET_EVERBRIDGEGROUP,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEverbridgeGroupData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchEverbridgeGroupData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.everbridgeGroup = action.payload;
      })
      .addCase(fetchEverbridgeGroupData.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          'Unknown error occurred';
        state.status = Status.FAILED;
        state.error = action.error.message || null;
      });
  },
});

export const selector = (state: RootState) => state.everbridgeGroupApi;

export const reducer = listEverbridgeGroupSlice.reducer;
